export function moveOptionSelection(options, current, key) {
  const currentIndex = options.indexOf(current)
  const lastIndex = options.length - 1

  if (currentIndex === -1) {
    return options[0] ?? null
  }

  if (key === 'Home') {
    return options[0] ?? null
  }

  if (key === 'End') {
    return options[lastIndex] ?? null
  }

  if (key === 'ArrowDown' || key === 'ArrowRight') {
    return options[(currentIndex + 1) % options.length] ?? null
  }

  if (key === 'ArrowUp' || key === 'ArrowLeft') {
    return options[(currentIndex - 1 + options.length) % options.length] ?? null
  }

  return current
}

export function isOptionNavigationKey(key) {
  return ['ArrowDown', 'ArrowUp', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(key)
}
